import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { ArrowLeft, Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
      toast.success('Se han enviado las instrucciones a tu email');
    } catch (error) {
      toast.error('Error al procesar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex flex-col items-center space-y-2 mb-4">
            <img src="/hi-tec-logo.png" alt="HI-TEC" className="h-16" />
            <h1 className="text-3xl font-bold text-black">HI-TEC <span className="text-blue-600">B2B</span></h1>
          </Link>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border-2 border-black p-8">
          <div className="flex items-center mb-6">
            <Link to="/login" className="mr-4">
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <h2 className="text-2xl font-bold text-black">¿Olvidaste tu contraseña?</h2>
          </div>

          {!submitted ? (
            <>
              <p className="text-gray-600 mb-6">
                Introduce tu email y te enviaremos instrucciones para restablecer tu contraseña.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label htmlFor="email">Email</Label>
                  <div className="relative mt-1">
                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="pl-10 border-gray-300"
                      placeholder="tu@email.com"
                    />
                  </div>
                </div>

                <Button
                  type="submit"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                  disabled={loading}
                >
                  {loading ? 'Enviando...' : 'Enviar instrucciones'}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center py-4">
              <div className="mb-4">
                <Mail className="w-16 h-16 text-blue-600 mx-auto" />
              </div>
              <h3 className="text-xl font-bold text-black mb-2">Email enviado</h3>
              <p className="text-gray-600 mb-6">
                Si existe una cuenta con el email <strong>{email}</strong>, recibirás instrucciones para restablecer tu contraseña.
              </p>
              <p className="text-sm text-gray-500 mb-6">
                Revisa tu bandeja de entrada y la carpeta de spam.
              </p>
              <Link to="/login">
                <Button variant="outline" className="w-full">
                  Volver al inicio de sesión
                </Button>
              </Link>
            </div>
          )}

          <div className="mt-6 text-center">
            <Link to="/login" className="text-blue-600 hover:text-blue-700 text-sm">
              Volver al inicio de sesión
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
